// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"249a5469","196":"b3cda9a7","946":"eaab0065"}[chunkId] + ".chunk.css";
};